import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { createRoot } from 'react-dom/client';
import { appStarted } from 'app/init';
import { App } from './app';
import { BugSnagProvider } from './providers';

dayjs.extend(utc);

appStarted();

createRoot(document.getElementById('root')!).render(
	<BugSnagProvider>
		<App />
	</BugSnagProvider>,
);
